import ConfirmationModal from './ConfirmationModal';
import { createConfirmation } from 'react-confirm';

const defaultConfirmation = createConfirmation(ConfirmationModal);

export function confirmationModal(confirmation, options = {}) {
  return defaultConfirmation({ confirmation, ...options });
}
